import AboutStep from '@/components/AboutStep.vue';
import ContactStep from '@/components/ContactStep.vue';
import PaymentsCancelled from '@/components/PaymentsCancelled.vue';
import PaymentStep from '@/components/PaymentStep.vue';
import PaymentsValidated from '@/components/PaymentsValidated.vue';
import PrintDocument from '@/components/PrintDocument.vue';
import SelectOptions from '@/components/SelectOptions.vue';
import UploadStep from '@/components/UploadStep.vue';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/:id?',
    name: 'UploadStep',
    component: UploadStep,
    props: true,
  }, {
    path: '/contact',
    name: 'Contact',
    component: ContactStep
  },
  {
    path: '/cancel',
    name: 'PaymentsCancelled',
    component: PaymentsCancelled,
  },
  {
    path: '/success',
    name: 'PaymentsValidated',
    component: PaymentsValidated,
  },
  {
    path: '/about',
    name: 'About',
    component: AboutStep
  },
  {
    path: '/select-options',
    name: 'SelectOptions',
    component: SelectOptions,
  },
  {
    path: '/payment',
    name: 'PaymentStep',
    component: PaymentStep,
  },
  {
    path: '/print-document',
    name: 'PrintDocument',
    component: PrintDocument,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
